import { useState, useLayoutEffect } from 'react';

const INTERVAL_MS = 500;

/**
 * Subscribes to X position changes of given container.
 *
 * Potentially, `useIntersectionObserver` hook could be used instead,
 * but the main reason why it's done via interval here is because the visibility of elements
 * inside components like Carousel doesn't change, when the position does.
 */
export const useX = (containerRef: React.RefObject<Element>): number | null => {
    const [x, setX] = useState<number | null>(null);

    useLayoutEffect(() => {
        const intervalId = setInterval(() => {
            if (!containerRef.current) {
                return;
            }

            const container = containerRef.current;
            const { x } = container.getBoundingClientRect();
            setX(x);
        }, INTERVAL_MS);

        return () => {
            clearInterval(intervalId);
        };
    }, [containerRef]);

    return x;
};
